import { createFileRoute } from "@tanstack/react-router";
import { catalogContactRoute } from "@/app-clients/catalog-detail";

export const Route = createFileRoute("/_find/dog/$dogId/contact")({
    beforeLoad: catalogContactRoute.beforeLoad,
    component: () => null,
});
